<template>
  <footer>
    <router-link to="/" @click.native="toggleMap">
      <b-icon size="is-medium" icon="map-marker-outline" />
      <p>Map</p>
    </router-link>
    <router-link to="/sites"
      ><b-icon size="is-medium" icon="circle-slice-8" />
      <p>Sites</p>
    </router-link>
    <router-link to="" @click.native="shareModal = true">
      <b-icon size="is-medium" icon="export-variant" />
      <p>Share</p>
    </router-link>

    <b-modal
      :active="shareModal"
      has-modal-card
      destroy-on-hide
      trap-focus
      aria-role="dialog"
      aria-label="Share Modal"
      close-button-aria-label="Close"
      aria-modal
    >
      <template>
        <div class="modal-card" style="width:70%;margin: 0px auto;">
          <header class="modal-card-head">
            <p class="modal-card-title">Share</p>
            <button type="button" class="delete" @click="shareModal = false" />
          </header>
          <section class="modal-card-body rounded">
            <ShareNetwork
              network="facebook"
              url="https://historylab.squarespace.com/"
              title="History Lab breaks down barriers. Barriers between history and technology. Barriers between faculty and students. Barriers between traditional classroom instruction and transdisciplinary experiential learning."
              description="We’re the History Lab team: a transdisciplinary group of faculty and students using digital technologies to rethink the past. We’re historians, computer scientists, librarians, educators, and artists combining disciplines as we engage in innovative historical storytelling."
              hashtags="virginiatech, vt150, historylab"
            >
              <div class="social-container">
                <i class="fab fah fa-lg fa-facebook"></i>
                <span>Share on Facebook</span>
              </div>
            </ShareNetwork>
            <ShareNetwork
              network="twitter"
              url="https://historylab.squarespace.com/"
              title="History Lab breaks down barriers. Barriers between history and technology. Barriers between faculty and students. Barriers between traditional classroom instruction and transdisciplinary experiential learning."
              description="We’re the History Lab team: a transdisciplinary group of faculty and students using digital technologies to rethink the past. We’re historians, computer scientists, librarians, educators, and artists combining disciplines as we engage in innovative historical storytelling."
              twitter-user="historyviz"
              hashtags="virginiatech, vt150, historylab"
            >
              <div class="social-container">
                <i class="fab fah fa-lg fa-twitter"></i>
                <span>Share on Twitter</span>
              </div>
            </ShareNetwork>
            <ShareNetwork
              network="linkedIn"
              url="https://historylab.squarespace.com/"
              title="History Lab breaks down barriers. Barriers between history and technology. Barriers between faculty and students. Barriers between traditional classroom instruction and transdisciplinary experiential learning."
              description="We’re the History Lab team: a transdisciplinary group of faculty and students using digital technologies to rethink the past. We’re historians, computer scientists, librarians, educators, and artists combining disciplines as we engage in innovative historical storytelling."
            >
              <div class="social-container">
                <i class="fab fah fa-lg fa-linkedin"></i>
                <span>Share on LinkedIn</span>
              </div>
            </ShareNetwork>
            <ShareNetwork
              network="reddit"
              url="https://historylab.squarespace.com/"
              title="History Lab breaks down barriers. Barriers between history and technology. Barriers between faculty and students. Barriers between traditional classroom instruction and transdisciplinary experiential learning."
              description="We’re the History Lab team: a transdisciplinary group of faculty and students using digital technologies to rethink the past. We’re historians, computer scientists, librarians, educators, and artists combining disciplines as we engage in innovative historical storytelling."
            >
              <div class="social-container">
                <i class="fab fah fa-lg fa-reddit"></i>
                <span>Share on Reddit</span>
              </div>
            </ShareNetwork>
            <ShareNetwork
              network="email"
              url="https://historylab.squarespace.com/"
              title="History Lab breaks down barriers. Barriers between history and technology. Barriers between faculty and students. Barriers between traditional classroom instruction and transdisciplinary experiential learning."
              description="We’re the History Lab team: a transdisciplinary group of faculty and students using digital technologies to rethink the past. We’re historians, computer scientists, librarians, educators, and artists combining disciplines as we engage in innovative historical storytelling."
            >
              <div class="social-container">
                <i class="fab fa-2x fa-envelope"></i>
                <span>Share via Email</span>
              </div>
            </ShareNetwork>
          </section>
        </div>
      </template>
    </b-modal>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      shareModal: false
    };
  },
  computed: {
    currentAudio() {
      return this.$store.state.currentAudio;
    },
    playState() {
      return this.$store.state.audioPlayState;
    }
  },
  methods: {
    toggleMap() {
      this.$store.commit("setMapVisibility", true);
      this.$store.commit("setFocus", true);
      if (this.playState) {
        this.$store.commit("setAudioPlayState", false);
        this.currentAudio.pause();
      }
    }
  }
};
</script>

<style lang="scss">
a[class^="share-network-"] {
  padding: 8px 0;
  font-size: 0.75rem;

  .social-container {
    width: 70%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
}

a.share-network-email {
  padding: 3px 0;
  font-size: 0.75rem;

  .social-container {
    width: 70%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
  }
}

.rounded {
  border-radius: 0 0 6px 6px;
}

footer {
  display: flex !important;
  justify-content: space-around;
  width: 100%;
  background-color: $white;
  box-shadow: 0px -4px 4px rgba(48, 47, 47, 0.25);

  a {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: x-small;
    color: $darkGrey;
    span {
      color: $darkGrey;
    }
  }
}
</style>
